import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
import React, { useMemo, useState } from 'react'; // Import useMemo

const TicketsStatsModal = ({ title, tickets, handleTicketClick }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Trier les tickets par ticketId en utilisant useMemo pour éviter un tri à chaque rendu
  const sortedTickets = useMemo(() => {
    if (!tickets) return [];
    return [...tickets].sort((a, b) => {
      // Comparaison numérique des IDs
      return a.ticketId.localeCompare(b.ticketId);
    });
  }, [tickets]);

  const getPaginatedData = (data) => {
    if (!data) return [];
    const startIndex = page * rowsPerPage;
    return data.slice(startIndex, startIndex + rowsPerPage);
  };

  return (
    <Box mb={2}>
      <Typography variant="subtitle2">{title} :</Typography>
      <TableContainer>
        <Table aria-label={`${title.toLowerCase().replace(' ', '-')}-table`}>
          <TableHead>
            <TableRow>
              <TableCell>Référence</TableCell>
              <TableCell>ID du Ticket</TableCell>
              <TableCell>ID du Projet</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {getPaginatedData(sortedTickets).map(
              (
                ticket // Utiliser sortedTickets
              ) => (
                <TableRow key={ticket.ticketId}>
                  <TableCell component="th" scope="row">
                    {ticket.reference}
                  </TableCell>
                  <TableCell>{ticket.ticketId}</TableCell>
                  <TableCell>{ticket.projectId}</TableCell>
                  <TableCell>
                    <Button
                      onClick={() => handleTicketClick(ticket)}
                      size="small"
                    >
                      Voir
                    </Button>
                  </TableCell>
                </TableRow>
              )
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={sortedTickets?.length || 0} // Utiliser la longueur du tableau trié
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Box>
  );
};

export default TicketsStatsModal;
